import React from "react";
import { Table, Tag } from "antd";

// Props: data is passed from parent
const ManagerProfileTable = ({ data }) => {
  const columns = [
    {
      title: "Profile ID",
      dataIndex: "profile_id",
      key: "profile_id",
    },
    {
      title: "Full Name",
      dataIndex: "profile_fullname",
      key: "profile_fullname",
    },
    {
      title: "Username",
      dataIndex: "profile_username",
      key: "profile_username",
    },
    {
      title: "Role",
      dataIndex: "profile_role",
      key: "profile_role",
      render: (role) => (role === 2 ? "Manager" : role),
    },
    {
      title: "Email",
      dataIndex: "profile_email",
      key: "profile_email",
    },
    // {
    //   title: "Project IDs",
    //   dataIndex: "project_id",
    //   key: "project_id",
    //   render: (text) =>
    //     text.split(",").map((id, index) => (
    //       <Tag color="blue" key={index}>
    //         {id.trim()}
    //       </Tag>
    //     )),
    // },
  ];

  const dataSource = data.map((item) => ({
    ...item,
    key: item.profile_id,
  }));

  return (
    <div style={{ padding: 24 }}>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </div>
  );
};

export default ManagerProfileTable;
